module.exports = __webpack_public_path__ + "static/media/lucy_grifthorst.08406240.jpg";